import type { FC, PropsWithChildren } from 'react'

import sanitizeHtml from 'sanitize-html'

import React from 'react'

import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import Typography from '@segment/matcha/components/Typography'

import * as CopyText from '@segment/matcha/recipes/CopyText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const PARAGRAPH = `<strong>Disclaimer:</strong> This report contains statistical data, estimates, and expectations that are based on publicly available information, as well as other information based on our internal sources or collected through our commercial relationships. These do not represent, and should not be construed as indicators of Twilio’s historical or future financial performance or the actual or potential demand for Twilio's products and solutions, and such information is solely presented as context for broader market trends.`
const list = [
  `Twilio Segment conducted this research using an online survey prepared by <a href="https://www.methodcommunications.com/methodresearch/">Method Research</a> and distributed by <a href="https://www.cint.com/">Cint</a> among n=2,450 full-time employees familiar with the company’s growth strategy working in marketing, engineering, UX, product, and customer services roles at B2B companies with 75+ employees.`,
  `The sample consisted of n=1,000 respondents from the United States, n=300 from each of the United Kingdom, Brazil, Germany, and France; and n=250 from Australia. Data was collected from August 3 to August 30, 2023.`,
]

const copy = {
  overline: `Methodology`,
}

const Methodology: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper id="methodology">
      <StyledSectionBase variant="noCopy">
        <Section.Contents>
          <StyledCopyTextOverline tag="h2" variant="overline">
            {copy.overline}
          </StyledCopyTextOverline>
          <StyledDivider />
          <ul>
            {list.map((item, index) => (
              <Typography
                variant="pSmall"
                tag="li"
                key={index}
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(item, { allowedTags: [`a`] }) }}
              />
            ))}
          </ul>
          <Typography
            variant="pSmall"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(PARAGRAPH, { allowedTags: [`strong`] }) }}
          />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding: 0;
  }
`

const StyledCopyTextOverline = styled(CopyText.Overline)`
  text-transform: none;
  letter-spacing: 0;
`

const StyledDivider = styled(Divider)`
  margin: 25px 0 0;
`

export default Methodology
